import { handleActions } from 'redux-actions';

import { OrderTravellers } from '../types';
import { setTravellers } from './actions';

const initialState: OrderTravellers = {};

const travellersReducer = handleActions(
	{
		[setTravellers.toString()]: (_, { payload }) => payload
	},
	initialState
);

export default travellersReducer;
